<template>
	<a-modal :title="isUpdate ? '修改用户' : '新增用户'" :width="640" :visible="visible" :confirmLoading="loading"
		:maskClosable="false" @ok="handleOk" @cancel="handleCancel">
		<a-spin :spinning="loading">
			<a-form-model ref="adminForm" :model="userForm" :label-col="{span:6}" :wrapper-col="{span:14}" autoComplete="off">
				<a-form-model-item v-show="false" label="ID" prop="id">
					<a-input type="hidden" v-model.number="userForm.id" />
				</a-form-model-item>
				<a-form-model-item label="昵称" prop="nickname"
					:rules="[{ required: true, message: '必填，不能为空', trigger: 'blur' }]">
					<a-input v-model="userForm.nickname" style="width:200px" />
				</a-form-model-item>
				<a-form-model-item label="性别" prop="sex"
					:rules="[{ required: true, message: '必填，不能为空', trigger: 'change' }]">
					<a-select v-model="userForm.sex" style="width:100px" placeholder="请选择">
						<a-select-option value="MALE">男</a-select-option>
						<a-select-option value="FEMALE">女</a-select-option>
					</a-select>
				</a-form-model-item>
				<a-form-model-item label="年龄" prop="age"
					:rules="[{ required: true, message: '必填，不能为空', trigger: 'change' }]">
					<a-input-number v-model="userForm.age" :min="18" :max="70" />
				</a-form-model-item>
				<a-form-model-item label="头像" prop="avatar"
					:rules="[{ required: true, message: '必填，不能为空', trigger: 'change' }]">
					<x-image v-if="userForm.avatar"
						:src="userForm.avatar"
						:preview-src="userForm.avatar + '?x-oss-process=image/resize,w_64,h_64,m_fill'" />
					<a-upload listType="picture" :multiple="false" :showUploadList="false" :customRequest="picUpload">
						<a-button><a-icon type="upload" />上传</a-button>
					</a-upload>
				</a-form-model-item>

				<a-form-model-item label="相册" prop="photos">
					<a-input v-show="false" v-model="userForm.photos" />

					<a-upload :customRequest="photosUpload" list-type="picture-card" :file-list="photosFileList"
						:multiple="true" :beforeUpload="photosBeforeUpload" @change="photosHandleChange"
						@preview="photosHandlePreview" @remove="photosHandleRemove" accept="image/*">
						<div v-if="photosFileList.length < 8">
							<a-icon type="plus" />
							<div class="ant-upload-text">上传图片</div>
						</div>
					</a-upload>

					<a-modal :visible="photosPreviewVisible" :footer="null" @cancel="photosPreviewVisible = false">
						<img alt="预览图片" style="width: 100%" :src="photosPreviewImage" />
					</a-modal>
				</a-form-model-item>
				<a-form-model-item label="声音秀" prop="voiceMotto">
					<a-input v-show="false" v-model="userForm.voiceMotto" />

					<a-upload name="file" :file-list="voiceFileList" :multiple="false" :beforeUpload="voiceBeforeUpload"
						:customRequest="voiceUpload" @change="voiceHandleChange" @remove="handleRemove" listType="text"
						:showUploadList="{
						showPreviewIcon: true,
						showRemoveIcon: true,
						showDownloadIcon: false
						}">
						<a-button>
							<a-icon type="upload" /> 上传声音
						</a-button>
					</a-upload>
				</a-form-model-item>
				<a-form-model-item label="身高" prop="height"
					:rules="[{ required: true, message: '必填，不能为空', trigger: 'change' }]">
					<a-input-number v-model="userForm.height" :min="120" :max="250" /> cm
				</a-form-model-item>
				<a-form-model-item label="婚姻状况" prop="maritalStatus"
					:rules="[{ required: true, message: '必填，不能为空', trigger: 'change' }]">
					<a-select v-model="userForm.maritalStatus" style="width:100px" placeholder="请选择">
						<a-select-option :value="1">单身</a-select-option>
						<a-select-option :value="2">恋爱中</a-select-option>
						<a-select-option :value="3">离异</a-select-option>
						<a-select-option :value="4">丧偶</a-select-option>
						<a-select-option :value="5">已婚</a-select-option>
						<a-select-option :value="6">保密</a-select-option>
					</a-select>
				</a-form-model-item>
				<a-form-model-item label="学历" prop="qualification"
					:rules="[{ required: true, message: '必填，不能为空', trigger: 'change' }]">
					<a-select v-model="userForm.qualification" style="width:100px" placeholder="请选择">
						<a-select-option :value="1">小学</a-select-option>
						<a-select-option :value="2">初中</a-select-option>
						<a-select-option :value="3">中专</a-select-option>
						<a-select-option :value="4">高中</a-select-option>
						<a-select-option :value="5">大专</a-select-option>
						<a-select-option :value="6">本科</a-select-option>
						<a-select-option :value="7">硕士</a-select-option>
						<a-select-option :value="8">博士</a-select-option>
					</a-select>
				</a-form-model-item>
				<a-form-model-item label="工作" :required="true">
					<div style="display: flex; align-items: center">
						<a-form-model-item prop="professionTopId" :style="{ flex: 1, marginBottom: 0 }"
							:rules="[{ required: true, message: '必填，不能为空', trigger: 'change' }]">
							<a-select v-model="userForm.professionTopId" placeholder="请选择" @change="professionTopChange">
								<a-select-option v-for="professionTop in professionTopList" :value="professionTop.id"
									:key="professionTop.id">
									{{ professionTop.workName }}
								</a-select-option>
							</a-select>
						</a-form-model-item>
						<span :style="{ width: '24px', textAlign: 'center' }">-</span>
						<a-form-model-item prop="professionId" :style="{ flex: 1, marginBottom: 0 }"
							:rules="[{ required: true, message: '必填，不能为空', trigger: 'change' }]">
							<a-select v-model="userForm.professionId" placeholder="请选择">
								<a-select-option v-for="professionSecond in professionSecondList"
									:value="professionSecond.id" :key="professionSecond.id">
									{{ professionSecond.workName }}
								</a-select-option>
							</a-select>
						</a-form-model-item>
					</div>
				</a-form-model-item>

				<a-form-model-item label="年收入" prop="income"
					:rules="[{ required: true, message: '必填，不能为空', trigger: 'change' }]">
					<a-select v-model="userForm.income" style="width:160px" placeholder="请选择">
						<a-select-option :value="1">5w以下</a-select-option>
						<a-select-option :value="2">5万-10万</a-select-option>
						<a-select-option :value="3">10万-20万</a-select-option>
						<a-select-option :value="4">20万-30万</a-select-option>
						<a-select-option :value="5">30万-50万</a-select-option>
						<a-select-option :value="6">50万-100万</a-select-option>
						<a-select-option :value="7">100万以上</a-select-option>
					</a-select>
				</a-form-model-item>

				<a-form-model-item label="地区" :required="true">
					<div style="display: flex; align-items: center">
						<a-form-model-item prop="provinceId" :style="{ flex: 1, marginBottom: 0 }"
							:rules="[{ required: true, message: '必填，不能为空', trigger: 'change' }]">
							<a-select v-model="userForm.provinceId" placeholder="请选择" @change="provinceChange">
								<a-select-option v-for="province in provinceList" :value="province.id"
									:key="province.id">
									{{ province.name }}
								</a-select-option>
							</a-select>
						</a-form-model-item>
						<span :style="{ width: '24px', textAlign: 'center' }">-</span>
						<a-form-model-item prop="cityId" :style="{ flex: 1, marginBottom: 0 }"
							:rules="[{ required: true, message: '必填，不能为空', trigger: 'change' }]">
							<a-select v-model="userForm.cityId" placeholder="请选择">
								<a-select-option v-for="city in cityList" :value="city.id" :key="city.id">
									{{ city.name }}
								</a-select-option>
							</a-select>
						</a-form-model-item>
					</div>
				</a-form-model-item>

				<a-form-model-item label="签名" prop="motto">
					<a-textarea v-model="userForm.motto" :auto-size="{minRows:2, maxRows:5}" />
				</a-form-model-item>
			</a-form-model>
		</a-spin>
	</a-modal>
</template>

<script>
	import pick from 'lodash.pick';
	import XImage from "@/components/XImage";
	import {
		uploadImage,
		uploadVoice
	} from '@/api/app';
	import {
		areaProvinceList,
		areaCityList
	} from '@/api/system/area';
	import {
		professionTopList,
		professionSecondList
	} from '@/api/system/profession';

	const MODEL_PICK_KEYS = ['id', 'nickname', 'sex', 'age', 'photos', 'voiceMotto', 'voiceMottoLen', 'provinceId',
		'cityId', 'motto', 'maritalStatus', 'height', 'qualification', 'income', 'professionId', 'professionTopId'
	];

	function emptyUserForm() {
		return {
			id: 0,
			nickname: '',
			sex: undefined,
			age: undefined,
			avatar: '',
			photos: '',
			voiceMotto: '',
			voiceMottoLen: 0,
			provinceId: undefined,
			cityId: undefined,
			motto: '',
			maritalStatus: undefined,
			height: undefined,
			qualification: undefined,
			income: undefined,
			professionId: undefined,
			professionTopId: undefined,
		};
	}

	function getBase64(file) {
		return new Promise((resolve, reject) => {
			const reader = new FileReader();
			reader.readAsDataURL(file);
			reader.onload = () => resolve(reader.result);
			reader.onerror = error => reject(error);
		});
	}

	export default {
		components: {
			XImage
		},
		props: {
			visible: {
				type: Boolean,
				required: true
			},
			loading: {
				type: Boolean,
				default: () => false
			},
			model: {
				type: Object,
				default: () => null
			}
		},
		data() {
			return {
				userForm: emptyUserForm(),
				provinceList: [],
				cityList: [],
				voiceFileList: [],
				photosFileList: [],
				photosPreviewVisible: false,
				photosPreviewImage: '',
				professionTopList: [],
				professionSecondList: [],
			}
		},
		watch: {
			model: {
				handler(val) {
					if (!val) {
						this.initForm();
						return;
					}
					Object.assign(this.userForm, emptyUserForm(), pick(val, MODEL_PICK_KEYS));
					this.userForm.avatar = (val.avatarUrl && val.avatarUrl !== '') ? val.avatarUrl : (val.avatar || '');
					if (val.voiceMottoLen != null && val.voiceMottoLen !== '') {
						this.userForm.voiceMottoLen = Number(val.voiceMottoLen) || 0;
					} else {
						this.userForm.voiceMottoLen = 0;
					}
					if (val.voiceMotto) {
						this.userForm.voiceMotto = val.voiceMotto;
					} else {
						this.userForm.voiceMotto = '';
					}
					if (val.photos) {
						const photoUrls = val.photos.split(',');
						this.photosFileList = photoUrls.map(url => ({
							uid: `photo-${url}-${Date.now()}`,
							name: url.split('/').pop() || 'photo.jpg',
							status: 'done',
							url: url,
							response: {
								data: {
									url
								}
							}
						}));
						this.userForm.photos = val.photos;
					} else {
						this.photosFileList = [];
						this.userForm.photos = '';
					}
					if (val.voiceMotto) {
						this.voiceFileList = [{
							uid: `voice-${val.voiceMotto}-${Date.now()}`,
							name: val.voiceMotto.split('/').pop() || 'voice.mp3',
							status: 'done',
							url: val.voiceMotto,
							response: {
								data: {
									url: val.voiceMotto
								}
							}
						}];
					} else {
						this.voiceFileList = [];
					}
					if (val.provinceId != null && val.provinceId !== '') {
						this.initCity(val.provinceId);
					}
					if (val.professionTopId != null && val.professionTopId !== '') {
						this.initSecondProfession(val.professionTopId);
					}
					this.$nextTick(() => {
						if (this.$refs.adminForm) {
							this.$refs.adminForm.clearValidate();
						}
					});
				},
				deep: true,
				immediate: true
			}
		},
		created() {
			this.fetchProvinceList();
			this.fetchProfessionTopList();
		},
		computed: {
			isUpdate: function() {
				return this.model && this.model.id > 0 ? true : false;
			}
		},
		methods: {
			initForm() {
				this.userForm = emptyUserForm();
				this.voiceFileList = [];
				this.photosFileList = [];
				this.photosPreviewVisible = false;
				this.photosPreviewImage = '';
				this.$nextTick(() => {
					if (this.$refs.adminForm) {
						this.$refs.adminForm.clearValidate();
					}
				});
			},
			picUpload(file) {
				const self = this;
				const formData = new FormData();
				formData.append('xupload', file.file);
				formData.append('type', 'avatar');

				uploadImage(formData).then(res => {
					if (res.isSucceed) {
						this.userForm.avatar = res.data.url;
					} else {
						self.$message.error(`上传图片错误：${res.data.message}`);
					}
				});
			},

			photosBeforeUpload(file) {
				const isImage = file.type.startsWith('image/');
				if (!isImage) {
					this.$message.error('只能上传图片文件!');
					return false;
				}

				const isLt5M = file.size / 1024 / 1024 < 5;
				if (!isLt5M) {
					this.$message.error('图片大小不能超过5MB!');
					return false;
				}

				if (this.photosFileList.length >= 9) {
					this.$message.error('最多只能上传9张图片!');
					return false;
				}

				return true;
			},

			photosUpload({
				file,
				onProgress,
				onSuccess,
				onError
			}) {
				const formData = new FormData();
				formData.append('xupload', file);
				formData.append('type', 'album');

				if (!file.uid) {
					file.uid = `photo-${Date.now()}-${Math.random().toString(36).substr(2, 6)}`;
				}

				uploadImage(formData, {
					onUploadProgress: (progressEvent) => {
						const percent = Math.round(
							(progressEvent.loaded * 100) / progressEvent.total
						);
						onProgress({
							percent
						}, file);
					}
				}).then(response => {
					if (response.isSucceed) {
						const responseWithUrl = {
							...response,
							data: {
								...response.data,
								url: response.data.url
							}
						};
						onSuccess(responseWithUrl, file);
					} else {
						onError(new Error(response.message || '上传失败'), file);
					}
				}).catch(error => {
					onError(error, file);
				});
			},

			photosHandleChange({
				fileList
			}) {
				this.photosFileList = fileList.map(f => {
					if (f.status === 'done' && f.response?.data?.url) {
						return {
							...f,
							uid: f.uid,
							url: f.response.data.url,
							name: f.name || `photo-${Date.now()}.jpg`
						};
					}
					if (f.status === 'uploading') {
						return {
							...f,
							uid: f.uid,
							name: f.name
						};
					}
					return f;
				}).filter(f => f.status !== 'error');

				const uploadedUrls = this.photosFileList
					.filter(f => f.status === 'done' && f.url)
					.map(f => f.url)
					.join(',');

				this.userForm.photos = uploadedUrls;
			},

			async photosHandlePreview(file) {
				if (file.url) {
					this.photosPreviewImage = file.url;
					this.photosPreviewVisible = true;
					return;
				}

				if (file.originFileObj) {
					try {
						const preview = await getBase64(file.originFileObj);
						this.photosPreviewImage = preview;
						this.photosPreviewVisible = true;
					} catch (error) {
						this.$message.error('图片预览生成失败');
					}
					return;
				}

				this.$message.warning('无法预览该图片');
			},

			photosHandleRemove(file) {
				return new Promise((resolve) => {
					this.$confirm({
						title: '确认删除',
						content: '确定要删除这张图片吗？',
						onOk: () => {
							const newFileList = this.photosFileList.filter(f => f.uid !== file.uid);
							this.photosFileList = newFileList;

							const uploadedUrls = newFileList
								.filter(f => f.status === 'done' && (f.url || (f.response && f.response.data && f.response.data.url)))
								.map(f => f.url || (f.response && f.response.data && f.response.data.url))
								.join(',');

							this.userForm.photos = uploadedUrls;

							resolve(true);
						},
						onCancel: () => resolve(false)
					});
				});
			},
			provinceChange(value) {
				this.fetchCityList(value);
				this.userForm.cityId = undefined;
			},
			initCity(value) {
				this.fetchCityList(value);
			},
			getAudioDuration(file) {
				return new Promise((resolve) => {
					const audio = document.createElement('audio')
					const url = URL.createObjectURL(file)

					audio.src = url
					audio.addEventListener('loadedmetadata', () => {
						this.userForm.voiceMottoLen = audio.duration;
						URL.revokeObjectURL(url)
						resolve(audio.duration)
					})

					audio.addEventListener('error', () => {
						URL.revokeObjectURL(url)
						this.$message.error('获取音频时长失败')
						resolve(0)
					})
				})
			},
			handleRemove(file) {
				return new Promise((resolve) => {
					this.$confirm({
						title: '确认删除',
						content: `确定要删除 ${file.name} 吗？`,
						onOk: () => {
							this.voiceFileList = [];
							this.userForm.voiceMotto = '';
							this.userForm.voiceMottoLen = 0;
							resolve(true);
						},
						onCancel: () => resolve(false)
					});
				});
			},
			voiceBeforeUpload(file) {
				const isAudio = ['audio/mpeg', 'audio/wav', 'audio/ogg'].includes(file.type);
				if (!isAudio) {
					this.$message.error('只能上传MP3、WAV或OGG格式的音频文件!');
					return false;
				}

				const isLt10M = file.size / 1024 / 1024 < 10;
				if (!isLt10M) {
					this.$message.error('音频文件大小不能超过10MB!');
					return false;
				}

				return this.getAudioDuration(file);
			},

			voiceUpload({
				file,
				onProgress,
				onSuccess,
				onError
			}) {
				const formData = new FormData();
				formData.append('xupload', file);

				if (!file.uid) {
					file.uid = `upload-${Date.now()}-${Math.random().toString(36).substr(2, 6)}`;
				}

				uploadVoice(formData, {
					onUploadProgress: (progressEvent) => {
						const percent = Math.round(
							(progressEvent.loaded * 100) / progressEvent.total
						);
						onProgress({
							percent
						}, file);
					}
				}).then(response => {
					if (response.isSucceed) {
						onSuccess({
							...response,
							data: {
								...response.data,
								uid: file.uid
							}
						}, file);
					} else {
						onError(new Error(response.message || '上传失败'), null, file);
					}
				}).catch(error => {
					onError(error, null, file);
				});
			},

			voiceHandleChange({
				file,
				fileList
			}) {
				this.voiceFileList = fileList.map(f => ({
					...f,
					uid: f.uid || Date.now() + Math.random().toString(36).substr(2, 9)
				})).slice(-1);

				if (file.status === 'done') {
					this.userForm.voiceMotto = file.response?.data?.url || file.url;
					this.$message.success(`${file.name} 上传成功`);
				} else if (file.status === 'error') {
					this.$message.error(`${file.name} 上传失败: ${file.error?.message || ''}`);
				} else if (file.status === 'removed') {
					this.userForm.voiceMotto = '';
					this.userForm.voiceMottoLen = 0;
				}
			},
			handleOk() {
				this.$emit('ok');
			},
			handleCancel() {
				this.$emit('cancel');
				this.initForm();
			},
			fetchProvinceList() {
				areaProvinceList().then(res => {
					this.provinceList = res.data.provinceList;
				});
			},
			fetchCityList(pid) {
				areaCityList(pid).then(res => {
					this.cityList = res.data.cityList;
				});
			},
			fetchProfessionTopList() {
				professionTopList().then(res => {
					this.professionTopList = res.data.recordList;
				});
			},
			fetchProfessionSecondList(value) {
				professionSecondList(value).then(res => {
					this.professionSecondList = res.data.recordList;
				});
			},
			professionTopChange(value) {
				this.fetchProfessionSecondList(value);
				this.userForm.professionId = undefined;
			},
			initSecondProfession(value) {
				this.fetchProfessionSecondList(value);
			},
		}
	}
</script>

<style scoped>
	.ant-input-number-handler-wrap :deep(.ant-input-number-handler-wrap) {
		display: none;
	}
</style>
